import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  appAuthPageApiKey: {
    id: 'app.AuthPage.apiKey',
  },
  appAuthPageApiKeyPlaceholder: {
    id: 'app.AuthPage.apiKeyPlaceholder',
  },
  appAuthPageEmail: {
    id: 'app.AuthPage.email',
  },
  appAuthPageEmailPlaceholder: {
    id: 'app.AuthPage.emailPlaceholder',
  },
  appCommonCancel: {
    id: 'app.common.cancel',
  },
  appCommonContinue: {
    id: 'app.common.continue',
  },
  shellSettings: {
    id: 'app.inventory.shell.settings',
  },
  startupAddLocation: {
    id: 'app.inventory.startup.addLocation',
  },
  startupChangeEmail: {
    id: 'app.inventory.startup.changeEmail',
  },
  startupChooseLocation: {
    id: 'app.inventory.startup.chooseLocation',
  },
  startupChooseLocationBeforeContinuing: {
    id: 'app.inventory.startup.chooseLocationBeforeContinuing',
  },
  startupContinueWithLocation: {
    id: 'app.inventory.startup.continueWithLocation',
  },
  startupEnterLocationApiKey: {
    id: 'app.inventory.startup.enterLocationApiKey',
  },
  startupEnterLocationApiKeyToContinue: {
    id: 'app.inventory.startup.enterLocationApiKeyToContinue',
  },
  startupErrorSaveEmail: {
    id: 'app.inventory.startup.errorSaveEmail',
  },
  startupErrorSaveLocationApiKey: {
    id: 'app.inventory.startup.errorSaveLocationApiKey',
  },
  startupErrorSelectLocation: {
    id: 'app.inventory.startup.errorSelectLocation',
  },
  startupErrorValidateLocationApiKey: {
    id: 'app.inventory.startup.errorValidateLocationApiKey',
  },
  startupFromLink: {
    id: 'app.inventory.startup.fromLink',
  },
  startupInvalidLocationApiKey: {
    id: 'app.inventory.startup.invalidLocationApiKey',
  },
  startupLocationFallbackName: {
    id: 'app.inventory.startup.locationFallbackName',
  },
  startupLocationStep: {
    id: 'app.inventory.startup.locationStep',
  },
  startupOtherSavedLocations: {
    id: 'app.inventory.startup.otherSavedLocations',
  },
  startupRemoveLocation: {
    id: 'app.inventory.startup.removeLocation',
  },
  startupRemoveLocationConfirm: {
    id: 'app.inventory.startup.removeLocationConfirm',
  },
  startupUseLocation: {
    id: 'app.inventory.startup.useLocation',
  },
  startupValidatingLocationApiKey: {
    id: 'app.inventory.startup.validatingLocationApiKey',
  },
  startupYourEmail: {
    id: 'app.inventory.startup.yourEmail',
  },
});
